/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * UpSmith Dev API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetTagTypesParams,
  HTTPValidationError,
  TagTypeList,
} from ".././schema";
import { axiosInstance } from "../../lib/axios";
import type { ErrorType } from "../../lib/axios";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * @summary Get Tag Types
 */
export const getTagTypes = (
  tenantUuid: string,
  params?: GetTagTypesParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<TagTypeList>(
    {
      url: `/api/v1/tenants/${tenantUuid}/lead-gen/tag-types`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetTagTypesQueryKey = (
  tenantUuid: string,
  params?: GetTagTypesParams
) => {
  return [
    `/api/v1/tenants/${tenantUuid}/lead-gen/tag-types`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTagTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getTagTypes>>,
  TError = ErrorType<HTTPValidationError>,
>(
  tenantUuid: string,
  params?: GetTagTypesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTagTypes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTagTypesQueryKey(tenantUuid, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagTypes>>> = ({
    signal,
  }) => getTagTypes(tenantUuid, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantUuid,
    refetchOnWindowFocus: "always",
    staleTime: Infinity,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTagTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTagTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTagTypes>>
>;
export type GetTagTypesQueryError = ErrorType<HTTPValidationError>;

/**
 * @summary Get Tag Types
 */

export function useGetTagTypes<
  TData = Awaited<ReturnType<typeof getTagTypes>>,
  TError = ErrorType<HTTPValidationError>,
>(
  tenantUuid: string,
  params?: GetTagTypesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTagTypes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTagTypesQueryOptions(tenantUuid, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
